<template>
  <div id="signup" class="text-center container">
  <h5>新規登録</h5>
    <b-button @click="signUpWithGoogle" class="mt-5 btn btn-block btn-lg btn-google text-white">
      <span class="float-left"><font-awesome-icon :icon='["fab", "google"]' />
        &nbsp;&nbsp;&nbsp;Googleアカウントで登録
      </span>
    </b-button>
    <div class="mt-5">
      <b-form-input type="text" placeholder="メールアドレス" v-model="username" />
      <b-form-input type="password" placeholder="パスワード(6文字以上)" v-model="password" />
      <b-form-input type="password" placeholder="パスワード(確認用)" v-model="passwordConf" />
    </div>
    <div class="mt-3">
      <b-form-checkbox v-model="acceptFlg">
        <router-link to="/term">
          <a>利用規約</a>
        </router-link>
        と
        <router-link to="/privacy_policy">
          <a>プライバシーポリシー</a>
        </router-link>
        に同意する
      </b-form-checkbox>
    </div>
    <b-button variant="primary" class="btn btn-lg btn-primary btn-block mt-4"
      @click="signUp" :disabled="signUpDis || isSubmit">
      メールアドレスで登録
    </b-button>
    <p class="mt-3" @click="isGoogle = true"></p>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import { mapActions } from 'vuex';

export default {
  name: 'signup',
  data() {
    return {
      isGoogle: false,
      username: '',
      password: '',
      passwordConf: '',
      acceptFlg: false,
      isSubmit: false,
    };
  },
  computed: {
    signUpDis() {
      let ret = !this.username || !this.password || !this.passwordConf || !this.acceptFlg;
      ret = ret || this.password !== this.passwordConf || this.password.length < 6;
      return ret;
    },
  },
  methods: {
    ...mapActions([
      'setRedirect',
      'storeIsLoading',
    ]),
    signUp() {
      if (this.password === this.passwordConf) {
        this.storeIsLoading(true);
        this.isSubmit = true;
        firebase.auth().createUserWithEmailAndPassword(this.username, this.password)
          .then(() => {
            alert('アカウントを作成しました。');
            this.$router.push('/');
          })
          .catch((error) => {
            if (error.code === 'auth/weak-password') {
              alert('パスワードは6文字以上で入力してください');
            } else if (error.code === 'auth/email-already-in-use') {
              alert('登録済みのメールアドレスです。');
            } else {
              alert(error.message);
            }
          })
          .finally(() => {
            this.isSubmit = false;
            this.storeIsLoading(false);
          });
      } else {
        alert('パスワードとパスワード確認用が異なります。');
      }
    },
    signUpWithGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithRedirect(provider);
      this.setRedirect(true);
    },
  },
};
</script>

<style scoped>
#signup{
  max-width: 330px;
  margin-top: 40px;
  margin-bottom: 120px;
}

.v-enter-active, .v-leave-active {
  transition: opacity .2s;
}
.v-enter, .v-leave-to {
  opacity: 0;
}


</style>



// WEBPACK FOOTER //
// src/views/Signup.vue